import { lazy, Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import { LoadingScreen } from 'src/components/loading-screen';

const ArticlesPage     = lazy(() => import('src/pages/articles/articles'));
const ArticleDetailPage = lazy(() => import('src/pages/articles/article-detail'));

export const articleRoutes: RouteObject[] = [
  {
    path: 'articles',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <ArticlesPage />, index: true },
      { path: ':articleId/:slug?', element: <ArticleDetailPage /> },
    ],
  },
];